import React, { useState ,useEffect} from 'react'
import axios from '../httpServices/httpService';
import api from '../config.json'
import { generateAllReports } from './PDFDownloadComponent';

const PDFDownloader = () => {
    const [qualityData, setQualityData] = useState([])
 
    const [loader, setLoader] = useState(false)
    const [TotalPage, setTotalPage] = useState(5);

    const [inputData, setInputData] = useState({
        From: "2024-10-03",
        Till: "2024-10-03",
        InspectionType: ["IFM - Product - Msr"],
        ItemName: ["All"],
        ItemNumber: ["All"],
        Operation: ["Product IFM MSR"]
      });
    
      const [monthlyDataArray, setMonthlyDataArray] = useState([]);
    
      useEffect(() => {
        generateDailyData();
      }, []);
    
      const generateDailyData = () => {
        const start = new Date('2024-10-01');
        const end = new Date('2025-03-31'); // End of October
      
        const dataArray = [];
      
        let current = new Date(start);
      
        while (current <= end) {
          const dateStr = current.toISOString().split('T')[0];
      
          dataArray.push({
            ...inputData,
            From: dateStr,
            Till: dateStr
          });
      
          // Move to next day
          current.setDate(current.getDate() + 1);
        }
      
        setMonthlyDataArray(dataArray);
      };
      
      const chunkArray = (array, size) => {
        console.log(array,"lfjidj")
        const result = [];
        for (let i = 0; i < array.length; i += size) {
          result.push(array.slice(i, i + size));
        }
        return result;
      };
    
      console.log(monthlyDataArray,"gvdfhgihfb");
    const handleGetPdfData = async (query,data,DateTime) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'ViewReport', query)
            .then((result) => {
                console.log(result,"grouped by data ",query)

  const chunkedChecksheetData = chunkArray(result.data.null['IFM - Product - Msr'], 30);
  chunkedChecksheetData.forEach((tableData, index) => {
    setTimeout(() => {
    //   downloadPdf(tableData);
      generateAllReports([{pdfData:tableData, data:data, company:'test',DateTime }])
    }, index * 3000); // 3 seconds delay for each download
  })
                  
                
                // setPdfData(result.data);
                setLoader(false)
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }

    const handleGetData = async (inputData,type) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'GetReport', { query: inputData, PageSize: 10, Page: 1, RequestType: '' })
            .then((result) => {
                setLoader(false)

                if (type == "Default") {
                    const obj = { ...inputData, InspectionType: ["All"], ItemName: ["All"], ItemNumber: ["All"], Operation: ["All"] };
                    setInputData(obj);
                }
                console.log(result.data, "vfdkjvdkfvbk")
                setTotalPage(result.data.totalDocument);
                setQualityData(result.data.data);
                if (result.data && result.data.data.length > 0) {
                    const { InspectionType, Item, ItemNumber, Operation,_id,DateTime } = result.data.data[0]

                    handleGetPdfData({ Shift: "", ItemName: Item, From: DateTime, Till: DateTime, InspectionType, ItemNumber, Operation,_id },result.data.data[0],DateTime)
                }
              
                //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
            })

            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }
    return (<>
        <div>PDFDownloader</div>
        <button
  type="button"
  onClick={() => {
    monthlyDataArray.forEach((one, index) => {
      setTimeout(() => {
        handleGetData(one, 'Default');
      }, index * 6000); // 2 seconds gap between each
    });
  }}
>
  get data
</button>

    </>
    )
}

export default PDFDownloader